import { Box, Button, Grid, Tooltip, Typography } from "@mui/material";
import { FC } from "react";
import SaveIcon from "@mui/icons-material/Save";
import PrintIcon from "@mui/icons-material/Print";
import IosShareIcon from "@mui/icons-material/IosShare";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import TaskIcon from "@mui/icons-material/Task";
import DoneAllIcon from '@mui/icons-material/DoneAll';
interface PaperHeaderButtonsProps {
  handleSave?: () => void; // Optional since we removed save functionality
  handleDrucken: () => void;
  handleExport: () => void;
  isDocumentGenerated?: boolean; // New prop to track if document is generated
}

export const PaperHeaderButtons: FC<PaperHeaderButtonsProps> = ({
  handleDrucken,
  handleSave,
  handleExport,
  isDocumentGenerated = false,
}) => {
  return (
    <Box sx={{ padding: 1 }}>
      <Grid
        container
        alignItems="center"
        justifyContent={"space-between"}
        spacing={1}
      >
        {/* Empty left space */}
        <Grid item xs />

        {/* Centered Typography */}
        <Grid item xs={6}>
          <Typography
            variant="h5"
            gutterBottom
            textAlign={"center"}
            fontWeight={"bold"}
            color="#ffffff"
          >
            Zusammenfassung
          </Typography>
        </Grid>

        {/* Right side buttons */}
        <Grid item xs={0}>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Tooltip title="Urbelegbegleitschreiben">
              <Button
                onClick={handleDrucken}
                endIcon={
                  isDocumentGenerated ? <TaskIcon /> : <ArrowForwardIcon />
                }
                sx={{
                  borderRadius: 1,
                  backgroundColor: isDocumentGenerated
                    ? "grey.500"
                    : "success.main",
                  "&:hover": {
                    backgroundColor: isDocumentGenerated
                      ? "grey.600"
                      : "success.main",
                  },
                }}
              >
                {isDocumentGenerated ? "Erstellt" : "Weiter"}
              </Button>
            </Tooltip>
            <Button
              onClick={handleExport}
              endIcon={<DoneAllIcon />}
              sx={{
                borderRadius: 1,
              }}
            >
              Abschließen
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PaperHeaderButtons;
